import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f9cfc66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pool-details-epoch-table-item" }
const _hoisted_2 = { class: "mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTime(_ctx.items?.timestamp)), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t("Epoch")) + " " + _toDisplayString(_ctx.items?.epochNo), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.t("Slot")) + " " + _toDisplayString(_ctx.items?.slotNo), 1)
    ])
  ]))
}